import { Component } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';

@Component({
  name: 'bpc-display-field-default',
  components: {},
})
export default class DisplayFieldDefault extends mixins(AbstractDisplayField) {
  get isDefault() {
    return this.item['default'];
  }

  get defaultText() {
    return this.$t('global.default.is_default');
  }
}
